import router from 'routers/profile.router';
import {setupAjaxConfiguration} from "ajaxSetup";
import i18n from 'l10n';
import callingcodewithdefaultcountry from 'callingcodewithdefaultcountry';

require('js/traits/google-analytics');
setupAjaxConfiguration(router, undefined, undefined, callingcodewithdefaultcountry).then(() => console.log("Ajax setup done."));

// Changing the link of tellody prices according the lng of user
$('.i18n-href[href]').each(function () {
    const self = $(this);
    let href = self.attr('href');
    while (href.indexOf('{}') > -1)
        href = href.replace('{}', i18n.language);
    self.attr('href', href);
});